﻿import type { IKanbanLoadTracker } from '../types/modules/kanban';

const kanbanLoadTracker: IKanbanLoadTracker = {};

function firstLoadKanban(id: string, callback: () => void) {
    if (!kanbanLoadTracker[id]) {
        callback();
        kanbanLoadTracker[id] = true;
    }
}

function refreshKanbanOnVisible(kanbanId = '#kanbanView') {
    if ($(kanbanId).is(':visible')) {
        window.refreshKanban();
    }
}

function toggleGridKanbanPanel({ sender }: { sender: kendo.ui.Button }) {
    const kanbanId: string = '#kanbanView';
    const gridView = $('#gridView');
    const kanbanView = $(kanbanId);
    const toggleButton = sender.element;
    const kendoGrid = $('[data-role=grid]').data('kendoGrid');

    if (gridView.is(':visible')) {
        gridView.hide();
        window.firstLoadKanban(kanbanId, window.refreshKanban);
        kanbanView.show();
        toggleButton.text('Показать грид');
        window.adjustkanbahHeight();
    }
    else {
        gridView.show();
        if (kendoGrid?.dataItems()?.length) {
            window.rebindDataSource(kendoGrid);
        }
        kanbanView.hide();
        toggleButton.text('Показать канбан');
        window.adjustGridHeight();
    }
}

function adjustkanbahHeight() {
    const kanban = $('.kanban');
    const paddingBottom = 10;

    applyKanbanParentStyles(kanban, (kanban?.offset()?.top ?? 0) + 10, paddingBottom);

    let resizeTimeout: NodeJS.Timeout;
    $(window).on('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (kanban?.resize) {
                kanban.resize();
                applyKanbanParentStyles(kanban, (kanban?.offset()?.top ?? 0) + 10, paddingBottom);
            }
        });
    });
}

function applyKanbanParentStyles(kanban: JQuery<HTMLElement>, heightValue: number, paddingBottom: number) {
    kanban.css({
        'height': `calc(100vh - ${heightValue}px)`,
        'padding-bottom': `${paddingBottom}px`
    });
}

window.toggleGridKanbanPanel = toggleGridKanbanPanel;
window.applyKanbanParentStyles = applyKanbanParentStyles;
window.firstLoadKanban = firstLoadKanban;
window.refreshKanbanOnVisible = refreshKanbanOnVisible;
window.adjustkanbahHeight = adjustkanbahHeight;